module.exports = __webpack_public_path__ + "static/spotlight_clipped-33505056ba54a5ce661f8a9dc7f16dbb.png";